import type { AllItemsNodeFields, FieldValue } from './types';

interface AllItemsQueryArgs {
  first?: string;
  after?: string;
  container_Name?: string;
  orderBy?: string;
  q?: string;
  search?: string;
}

interface AllItemsEdges {
  node: AllItemsNodeFields;
}

interface AllItemsQueryResult {
  query: {
    allItems: {
      totalCount: FieldValue;
      __args: AllItemsQueryArgs;
      edges: AllItemsEdges;
    };
  };
}

export const allItemsQuery = (): AllItemsQueryResult => ({
  query: {
    allItems: {
      totalCount: true,
      __args: {
        // first: '',
        // after: '',
        // container_Name: '',
        // orderBy: '',
        // q: '',
        // search: '',
      },
      edges: {
        node: {},
      },
    },
  },
});

export const buildAllItemsQuery = (
  args: AllItemsQueryArgs = {},
  node: AllItemsNodeFields = {},
): AllItemsQueryResult => {
  const query = allItemsQuery();
  query.query.allItems.__args = { ...query.query.allItems.__args, ...args };
  query.query.allItems.edges.node = {
    ...query.query.allItems.edges.node,
    ...node,
  };
  return query;
};
